/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getEquipmentIPS } from 'app/entities/equipment-ip/equipment-ip.reducer';
import { getEntities as getPaymentSchemes } from 'app/entities/payment-scheme/payment-scheme.reducer';
import { ChargeType } from 'app/shared/model/enumerations/charge-type.model';
import { createEntity, getEntity, reset, updateEntity } from './equipment-ip-charges.reducer';

export const EquipmentIPChargesUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const equipmentIPS = useAppSelector(state => state.equipmentIP.entities);
  const paymentSchemes = useAppSelector(state => state.paymentScheme.entities);
  const equipmentIPChargesEntity = useAppSelector(state => state.equipmentIPCharges.entity);
  const loading = useAppSelector(state => state.equipmentIPCharges.loading);
  const updating = useAppSelector(state => state.equipmentIPCharges.updating);
  const updateSuccess = useAppSelector(state => state.equipmentIPCharges.updateSuccess);
  const chargeTypeValues = Object.keys(ChargeType);

  const handleClose = () => {
    navigate(`/equipment-ip-charges${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getEquipmentIPS({}));
    dispatch(getPaymentSchemes({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.price !== undefined && typeof values.price !== 'number') {
      values.price = Number(values.price);
    }
    if (values.maxDiscount !== undefined && typeof values.maxDiscount !== 'number') {
      values.maxDiscount = Number(values.maxDiscount);
    }
    if (values.startDate !== undefined && typeof values.startDate !== 'number') {
      values.startDate = Number(values.startDate);
    }
    if (values.endDate !== undefined && typeof values.endDate !== 'number') {
      values.endDate = Number(values.endDate);
    }

    const entity = {
      ...equipmentIPChargesEntity,
      ...values,
      equipment: equipmentIPS.find(it => it.id.toString() === values.equipment?.toString()),
      scheme: paymentSchemes.find(it => it.id.toString() === values.scheme?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          chargeType: 'HOURLY',
          ...equipmentIPChargesEntity,
          equipment: equipmentIPChargesEntity?.equipment?.id,
          scheme: equipmentIPChargesEntity?.scheme?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.equipmentIPCharges.home.createOrEditLabel" data-cy="EquipmentIPChargesCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.home.createOrEditLabel">
              Create or edit a EquipmentIPCharges
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="equipment-ip-charges-id"
                  label={translate('tinyMedicRestApp.equipmentIPCharges.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIPCharges.active')}
                id="equipment-ip-charges-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIPCharges.cursor')}
                id="equipment-ip-charges-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIPCharges.lastUpdated')}
                id="equipment-ip-charges-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIPCharges.microSec')}
                id="equipment-ip-charges-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIPCharges.timestampEntry')}
                id="equipment-ip-charges-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIPCharges.price')}
                id="equipment-ip-charges-price"
                name="price"
                data-cy="price"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIPCharges.maxDiscount')}
                id="equipment-ip-charges-maxDiscount"
                name="maxDiscount"
                data-cy="maxDiscount"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIPCharges.chargeType')}
                id="equipment-ip-charges-chargeType"
                name="chargeType"
                data-cy="chargeType"
                type="select"
              >
                {chargeTypeValues.map(chargeType => (
                  <option value={chargeType} key={chargeType}>
                    {translate(`tinyMedicRestApp.ChargeType.${chargeType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIPCharges.multiplierApplied')}
                id="equipment-ip-charges-multiplierApplied"
                name="multiplierApplied"
                data-cy="multiplierApplied"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIPCharges.startDate')}
                id="equipment-ip-charges-startDate"
                name="startDate"
                data-cy="startDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIPCharges.endDate')}
                id="equipment-ip-charges-endDate"
                name="endDate"
                data-cy="endDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIPCharges.suspended')}
                id="equipment-ip-charges-suspended"
                name="suspended"
                data-cy="suspended"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIPCharges.draft')}
                id="equipment-ip-charges-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <ValidatedField
                id="equipment-ip-charges-equipment"
                name="equipment"
                data-cy="equipment"
                label={translate('tinyMedicRestApp.equipmentIPCharges.equipment')}
                type="select"
              >
                <option value="" key="0" />
                {equipmentIPS
                  ? equipmentIPS.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="equipment-ip-charges-scheme"
                name="scheme"
                data-cy="scheme"
                label={translate('tinyMedicRestApp.equipmentIPCharges.scheme')}
                type="select"
              >
                <option value="" key="0" />
                {paymentSchemes
                  ? paymentSchemes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/equipment-ip-charges" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default EquipmentIPChargesUpdate;
